function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/display-name */
import React from 'react';
import { Text } from '../Text';

var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "h3"
  }, props));
};

Heading.displayName = 'Heading';

Heading.h1 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h1",
    textShadowSize: "md"
  }, props));
};

Heading.h2 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h2",
    textShadowSize: "md"
  }, props));
};

Heading.h3 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h3",
    textShadowSize: "sm"
  }, props));
};

Heading.h4 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h4",
    textShadowSize: "sm"
  }, props));
};

Heading.h5 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h5",
    textShadowSize: "sm"
  }, props));
};

Heading.h6 = function (props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h6",
    textShadowSize: "sm"
  }, props));
};

export default Heading;